import {createAction} from '@reduxjs/toolkit'

import {ModalCaseValues} from '@web/core/constants'

export const openModal = createAction<ModalCaseValues>('modal/openModal')

export const closeModal = createAction('modal/closeModal')
